// utils/exportToCSV.js

export const exportToCSV = (data, filename = "devices.csv") => {
  if (!data || data.length === 0) return;

  const headers = [
    "ID",
    "Device",
    "Product Code",
    "Classification",
    "Regulation #",
    "Applicant",
    "Decision Date",
    "Review Days",
    "Source",
  ];

  const escapeCSV = (value) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    return `"${str.replace(/"/g, '""')}"`; // escape quotes
  };

  const rows = data.map((item) => [
    item.id,
    item.device,
    item.productCode,
    item.classification,
    item.regulationNumber,
    item.applicant,
    item.decisionDate,
    item.reviewDays,
    item.sourceUrl,
  ]);

  const csvContent =
    [headers, ...rows]
      .map((row) => row.map(escapeCSV).join(","))
      .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};